<template>
    <div>
        <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                    <div class="col-12">
                        <h3 class="mb-0">เลือกขนส่งที่ต้องการเปิดใช้งาน</h3>
                    </div>
                </div>
            </div>
            <div class="col-12 box-select-courier">
                <b-form-group label="ประเภทขนส่ง SHIPPOP" v-if="listCourier.length > 0">
                    <b-form-checkbox-group
                        v-model="agent.selectedCourier"
                        :options="listCourier"
                        class="mb-3"
                        value-field="id"
                        text-field="name"
                        disabled-field="notEnabled"
                        stacked
                    ></b-form-checkbox-group>
                </b-form-group>
            </div>
        </card>
    </div>
</template>

<script>
import { getDefaultCourier } from "@/axios/courier.js";

export default {
    props:{
        agent: Object
    },
    data(){
        return{
            listCourier: []
        }
    },
    mounted(){
        getDefaultCourier().then( res => {
            this.listCourier = res.filter(( courier ) =>{
                courier.name = courier.name+ ' ' + courier.description
                return courier.is_shippop == 1 && ( courier.expired_date == null || new Date(courier.expired_date).getTime() >= new Date().getTime() )
            })
        });
    }
}
</script>